<template>
<div>
  <b-container fluid>
  <b-row v-if="!item || !item.nimi">
        <InfoCard></InfoCard>
  </b-row>
  <b-row v-else-if="item.routestops && item.routestops.length > 0" >  
     <b-col v-if= "showDestinations" :lg="cols">
     
          <div id="destinationDiv">
          
          <b-table hover 
            selectable 
            select-mode="single" 
            @row-selected="onRowSelected"        
            :items="form.destinations" 
            :responsive="false"
            :fields="fields"
            :small="true"
            :sort-by.sync="sortBy"            
            ref="destinationList"
            primary-key="tunnus">
            <template v-slot:cell(tunnus)="data">
                <p class="mb-0">            
                <b-form-group v-if='data.value != ""'>               
                    <b-icon icon="dash-square-fill" variant="danger" @click="remove(data.index)" 
                    font-scale="1.5" v-b-tooltip.hover :title="$t('destination.delete.destination')" 
                    class="clickable"></b-icon>
                </b-form-group>
                <b-form-group v-if='data.value == ""'>               
                    <b-icon icon="plus-square-fill" variant="success" @click="addDestination(data.value)" 
                    font-scale="1.5" v-b-tooltip.hover :title="$t('button.add')" 
                    class="clickable"></b-icon>
                </b-form-group>
            </p>
            </template>
          </b-table> 

          </div> 
        
      </b-col>
     </b-row>

   </b-container>
   <DeleteModal :modalid="'routeDestinationModal'" :itemid="destinationName" @ok="onDeleteOK" />
</div>
  
</template>

<script>
import timetable from '@/store/timetable/timetable'
import i18n from '@/i18n'
import copy from 'fast-copy';
import { mapState } from 'vuex'
import card  from '@/store/ui/card'

export default {
    components: {
    },
    data() {
        return {
            showForm: false,
            showDestinations: true,
            form: {
                destinations: [],
            },
            fields: [
                { key: 'jarjestys', label: "" },
                { key: 'pysakkinimi', label: this.$t('route_view.stop') },
                { key: 'kieli', label: this.$t('route_view.language'),
                    formatter: (value, key, item) => {  
                        let lang = this.systemLangs.find( lang => lang.id == item.kielikoodi )
                        if( lang != null )
                            return this.$t(lang.lang) 
                        return item.kielikoodi
                    } 
                },
                { key: 'nimi', label: this.$t('route_view.destination')},
                { key: 'kautta', label: this.$t('route_view.via')},
                { key: "tunnus", label: "" }
            ],
            sortBy:"jarjestys, kielikoodi",            
            destinationItem:{
                reitti:"",
                kielikoodi:"",
                nimi:"",
                kautta:"",
                jarjestys:"1"
            },
            selected: [],
            selectedDestination: null,
            formType: "new",
            systemLangs: [],
        }   
    },
    props: {
        item: {
            required: true,
        },
        action: { default: "new" }
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        if( !this.$store.state.card ) {
            this.$store.registerModule('card' , card )
        }
        this.$store.dispatch('getSystemParameters').then((result) => {
            let langs = [];
            Object.keys(result.system_languages).forEach(item => langs.push({"id": item, "lang": result.system_languages[item]}))
            this.systemLangs = langs;
        });
        this.getDestinations(this.item);
    },
    watch: {
        item: function(item) { 
            this.getDestinations(item);
        },
        destinations(data) {
            this.form.destinations = this.sortArray(data.destinations);
            if( this.form.destinations.length === 0 ) {
                this.showForm = true;
                this.showDestinations = false;
            } else {
                this.showForm = false;
                this.showDestinations = true;                        
            }
        }        
    }, 
    computed: {
        cols(){
            return this.showForm ? 8 : 12;
        },
        formTitle(){
            return i18n.t('item.' + this.formType);
        },        
        stopName() {
            return this.selected ? this.selected.pysakkinimi : "";
        },
        destinationName() {
            if( this.selected )
                return this.selected.nimi
            return this.selectedDestination ? this.selectedDestination.nimi : ""
        },
        route() {
            return this.form.tunnus;
        },
        selectedDestinations: function() {
            let destinationLangs = [];
            let destinationList = new Map();
            
            if( this.form.destinations ) {
                for( let d of this.form.destinations ) {
                    if( this.selected && d.jarjestys == this.selected.jarjestys ) {
                        d.reitti = this.route;
                        if( d.kielikoodi == null )
                            d.kielikoodi = this.systemLangs[0].id
                        destinationList.set( ""+d.kielikoodi , d)
                        destinationLangs.push(d.kielikoodi);
                    }
                }
            }
            for( let l of this.systemLangs ) {
                if( !this.listContains(l.id, destinationLangs) ) {
                    let newDest = Object.assign( {} , this.destinationItem );
                    newDest.kielikoodi = l.id;                
                    newDest.reitti = this.route ? this.route : "";
                    if( this.selected ) 
                        newDest.jarjestys = this.selected.jarjestys;                
                    destinationList.set(""+newDest.kielikoodi , newDest )
                    destinationLangs.push(l.id);
                }
            }
            return destinationList;
        },
        ...mapState( { 
            destinations: state => state.timetable.routes.destinations
        })
    },
    methods: {
        getDestinations(item) {
            this.form = JSON.parse(JSON.stringify(item));
            this.getDestinationsData(this.form.tunnus);
        },     
        refreshDestinations(routeId) {
            this.getDestinationsData(routeId);
        }, 
        getDestinationsData(routeId) {
            if( routeId ) {
                this.$store.dispatch('timetable/getRouteDestinations' , routeId ) /*
                    .then( response => {
                        this.form.destinations = this.sortArray(response.data.destinations);
                        if( this.form.destinations.length === 0 ) {
                            this.showForm = true;
                            this.showDestinations = false;
                        } else {
                            this.showForm = false;
                            this.showDestinations = true;                        
                        }

                }) */
            }        
        },
        sortArray: function(array) {
            function compare(a, b) {
                if (a.jarjestys < b.jarjestys) return -1;
                if (a.jarjestys > b.jarjestys) return 1;
                if (a.kielikoodi < b.kielikoodi) return -1;
                if (a.kielikoodi > b.kielikoodi) return 1;
                return 0;
            }
            return array.sort(compare);
        },                   
        showEditor: function(_show, type ) {
            this.formType = type;
            let destEditData = {}
            destEditData.selectedDestinations = this.selectedDestinations
            destEditData.formType = copy( this.formType )
            destEditData.stopName = copy( this.stopName )
            destEditData.route = copy( this.route )
            //this.$emit("showExtraCard" , { "card":"DestinationEdit", "data": destEditData } )
            this.$store.commit('card/showCard' , { place:3 , name:"DestinationEdit" , data:destEditData })
        },
        listContains(item, list) {
            for(const element of list) {
                if(element == item) {
                    return true;
                }
            }
            return false;
        },    
        onRowSelected: function(items) {
            this.selected = items[0];
            if( this.selected && !this.selectedDestination) {
                if( !this.selected.nimi == "" )
                    this.showEditor(true, "edit");
                else
                    this.showEditor(true, "new");
            }
        },
        addDestination: function() {
            this.showEditor(true, "new");
        },
        cancelRemove(item){
            this.selected = item;
        },
        remove(index){
            this.showForm = false;
            this.selectedDestination = this.form.destinations[index];       
            this.$bvModal.show('routeDestinationModal')
        },
        onDeleteOK: function() {                			
            this.$travellerRemove();
            this.$store.dispatch('timetable/deleteDestination' , this.selectedDestination, this.item.tunnus).then( () => {
                this.$travellerRemoved();
                this.$store.dispatch('timetable/getRouteDestinations' , this.item.tunnus )
                    .then( response => {
                        this.form.destinations = this.sortArray(response.data.destinations);
                        this.selected = {};
                        this.selectedDestination = null; 
                })
            });
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#destinationDiv {
  height: 40em;
  overflow: auto;
}
</style>

